var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app-bar",
    {
      staticStyle: { opacity: "0.95" },
      attrs: {
        app: "",
        fixed: "",
        dense: "",
        "elevate-on-scroll": "",
        color: "#E1F5FE"
      }
    },
    [
      _c(
        "v-btn",
        {
          attrs: { small: "", text: "", color: "primary" },
          on: {
            click: function($event) {
              _vm.drawerExpand = !_vm.drawerExpand
            }
          }
        },
        [
          _c("v-icon", { class: _vm.drawerExpand || "cstm-rotate--90" }, [
            _vm._v("mdi-menu")
          ])
        ],
        1
      ),
      _c("v-spacer"),
      _c(
        "v-btn",
        {
          attrs: { fab: "", small: "", text: "" },
          on: { click: _vm.openLogout }
        },
        [_c("v-icon", { staticClass: "primary--text" }, [_vm._v("mdi-power")])],
        1
      ),
      _c("logout-dialog", { ref: "logout-dialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }